<template>
  <div class="activate-account">
    <div class="logo">
    </div>

    <div class="message-container" v-if="!responseReceived">
      <h2>Attempting to Activate</h2>
      <div>
        Please wait...
      </div>
    </div>

    <div class="message-container" v-if="activatedUser">
      <h2>Success!</h2>
      <div>
        Your account has been activated.
      </div>

      <div class="return-to-login" v-on:click="login">
        Click here to login.
      </div>

      {{errorMessage}}
    </div>

    <div class="message-container" v-if="error">
      <h2>Activation Failed</h2>
      <div>
        An error occurred while activating your account: {{errorMessage}}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import '../styles/base.css'

export default {
  name: 'ActivateAccount',

  computed: {
    responseReceived: function () {
      return this.error || this.activatedUser
    }
  },

  data () {
    return {
      activatedUser: false,
      error: false,
      errorMessage: ''
    }
  },

  mounted () {
    this.activate()
  },

  methods: {
    activate: function () {
      axios.get('/api/activation', {
        params: {
          hash: this.hash
        }
      })
        .then((response) => {
          this.activatedUser = true
        })
        .catch((err) => {
          this.errorMessage = err
          this.error = true
        })
    },

    login: function () {
      this.$router.push('/login')
    }
  },

  props: ['hash']

  // watch: {
  //   hash: function (newVal, oldVal) {
  //     console.log('The hash inside: ', this.hash)
  //     if (oldVal) {
  //       this.activate()
  //     }
  //   }
  // }
}
</script>

<style scoped>
  .button {
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 400px;
  }

  .activate-account {
    align-items: center;
    background: url("../assets/images/login-bg.gif");
    height: 100vh;
    margin: 0 auto;
    overflow: auto;
    position: relative;
    width: 100vw;
  }

  .message-container {
    background: white;
    margin: 3em auto;
    padding: 1em;
    position: relative;
    text-align: center;
    width: 400px;
  }

  h2 {
    margin: 0;
  }

  .login-link {
    color: white;
    cursor: pointer;
    padding: 2em;
    text-align: center;
  }

  .login-link:hover {
    color: var(--primary);
  }

  .logo {
    border: 1px solid white;
    height: 100px;
    margin: 4em auto 4em auto;
    width: 200px;
  }

  .return-to-login {
    color: var(--primary);
    cursor: pointer;
    padding: 1em;
    text-align: center;
  }

  .return-to-login:hover {
    color: var(--primary-dark);
  }

  span {
    color: var(--primary);
  }

  @media only screen and (max-width: 420px) {
    .button {
      width: 300px;
    }

    .message-container {
      width: 300px;
    }

    input[type=text], input[type=phone], input[type=email], input[type=password], textarea {
      width: 300px;
    }

    .logo {
      width: 300px;
    }
  }
</style>
